// extracted by mini-css-extract-plugin
export default {"container":"WidthLimiter_container__b7OvO"};